import styled from 'styled-components';

const GlobalHeroSectionStyle = styled.section`
	--smallDistance: var(--sp4x);
	--largeDistance: var(--sp5x);
	--radiusSize: var(--sp3x);

	.left-inner-block {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}

	.right-inner-block {
		height: 100%;
		display: flex;
		flex-direction: column;
		justify-content: center;

		border-radius: var(--radiusSize);
		overflow: hidden;

		transition: clip-path 0.5s ease-out;
		clip-path: polygon(0 0, 0 0, 0 100%, 0 100%);

		&.clip-path {
			clip-path: polygon(0 0, 100% 0, 100% 100%, 0 100%);
		}
	}

	.description {
		white-space: pre-wrap;
		margin-top: var(--smallDistance);
	}

	.btn-block {
		margin-top: var(--largeDistance);
	}

	.image-cont {
		--proportion: 0;

		display: flex;
		border-radius: var(--radiusSize);
		overflow: hidden;

		transform: scale(1.1);

		&.scale {
			transform: scale(1);
			transition: transform 0.5s ease-out !important;
			will-change: transform;
		}

		img {
			position: relative !important;
			aspect-ratio: 1.14;

			border-radius: var(--radiusSize);
			overflow: hidden;
		}
	}

	.title {
		word-break: break-all !important;

		.line-initial {
			white-space: pre-wrap !important;
		}
	}

	/* //! 1920 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeXLMin}) {
		--radiusSize: var(--sp1-5x);
	}

	/* //! 1536 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeLMin}) {
		--smallDistance: var(--sp3x);
		--largeDistance: var(--sp4x);
	}

	/* //! 1366 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeMMin}) {
		--smallDistance: var(--sp2-5x);
		--largeDistance: var(--sp3x);
	}

	/* //! 1280 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.desktopSizeSMin}) {
	}

	/* //! 1024 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeMin}) {
		.empty-col {
			display: none;
		}
	}

	/* //! 768 */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeXMin}) {
		--radiusSize: var(--sp1x);

		.right-block {
			margin-top: var(--sp4x);
		}

		.empty-col {
			display: none;
		}
	}

	/* //! Mobile */
	@media only screen and (max-width: ${(props) => props.theme.mediaQuery.tabletSizeSMin}) {
		.right-block {
			margin-top: var(--sp3x);
		}
	}
`;

export default GlobalHeroSectionStyle;
